export const Faqs = [
  // {
  //     question:"Login new business user (Mitigate Risk Client)",
  //     isOpened:true,
  //     videoLink:'https://drive.google.com/file/d/1a267AV05jEvJ2TYIWGp821_D-igXYhhC/preview',
  //
  //   },
  {
    question: "How do I add users on the web application?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1CRer-zbI4YNFI2oSDbbqRq8XvYyDvkZ6/preview",
  },
  {
    question: "What should I do if I forget my password?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1-Q8EGbnqt3ed3oqn41oy6_DrAl3MR-0G/preview",
  },
  {
    question: "What actions can I perform on the web portal ?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1RVYzsgLZ0o5Jaub1d3XFinwdi9bj3jQ2/preview",
  },
  {
    question:
      "How can I manage users or request a new password on their behalf if I have the permissions to do so?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1K57UxlgPEsijlawOfHC5pN2OwKDp-FnR/preview",
  },
  {
    question: "How can I change my password within the app?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1DSq_yjaD1jLiT6Evs8t38blcjmY8MZkt/preview",
  },
  {
    question: "What's the process for assigning or editing user permissions?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/11V60Z5j7IO-f4NlJpO8_GKY4VLVJY8kb/preview",
  },
  {
    question:
      "How do I submit a new incident, edit existing incident or save draft incidents?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1sK5vvPpaBedxzCTrSrFl-y6KPW9PgpY9/preview",
  },
  // {
  //   question: "What are draft incidents and how do I handle them?",
  //   isOpened: false,
  //   videoLink:
  //     "https://drive.google.com/file/d/1uOCCBW3D9KJHNzjmyu6vE5gjmG0V14Pf/preview",
  // },
  {
    question:
      "How do I sign off on a reported incident if I have the permission to do so?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/13D323_2IY0eSugBxO_Eh-RlAkgBLF0JT/preview",
  },
  //   {
  //     question:"Incident Scoring",
  //     isOpened:false,
  //     videoLink:'https://drive.google.com/file/d/1M77xexA9DvwSJk17g7MH4O-efCH-kSGJ/preview',
  //   },
  //   {
  //     question:"Incident Priortization",
  //     isOpened:false,
  //     videoLink:'https://drive.google.com/file/d/1q7Q_DkNjd1_whxDFDynDIfufy7UGKffv/preview',
  //   },
  {
    question: "How can I analyze incidents from facilities?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1Jw-KWtQNu0kooeHZAkWH5e7TwhlstUee/preview",
  },
  {
    question: "How can I export an analytics report?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1Jw-KWtQNu0kooeHZAkWH5e7TwhlstUee/preview",
  },
  {
    question: "How can I report an Incident ?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1Ax47s8pnDfRg4PAhTowwApnsLBqydP4p/preview",
  },
  {
    question: "How can I report an Incident ?",
    isOpened: false,
    videoLink:
      "https://drive.google.com/file/d/1Ax47s8pnDfRg4PAhTowwApnsLBqydP4p/preview",
  },
  //   {
  //     question:"Add Business User",
  //     isOpened:false,
  //     videoLink:'https://drive.google.com/file/d/10PFvf19bF799Kk7mrJFUqzUaR_xQW3Gy/preview',
  //
  //   },
  //   {
  //     question:"Setup of Facilities in Salesforce",
  //     isOpened:false,
  //     videoLink:'https://drive.google.com/file/d/1LQ2bWsrHHa2hwOoTkIr0qmT5HIrkrXWP/preview',
  //
  //   },
  //   {
  //     question:"Review Incident Submitted",
  //     isOpened:false,
  //     videoLink:'https://drive.google.com/file/d/1KUw2P45TLCfayygsF53ABPCnLUqTZVGv/preview',
  //
  //   },
  //   {
  //     question:"Setup of signatory requirements in Salesforce",
  //     isOpened:false,
  //     videoLink:'https://drive.google.com/file/d/1gK32bm4NMs3mrQ_bz-0guXfcnZXMUor-/preview',
  //
  //   },
  //   {
  //     question:"Onboard user on PCC",
  //     isOpened:false,
  //     videoLink:'',
  //
  //   }
];
